import Controller, { OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';

import { CallCategoriesAliases as Aliases, FragmentNames } from '../../codegen';
import { Route } from '../../route';
import BaseController from '../BaseController';

import { CallCategory } from './calls-controller';

import './call-categories.css';

@Controller({ fragment: FragmentNames.CALL_CATEGORIES })
class CallCategoriesController extends BaseController {

  @OnSelectItem(Aliases.DECK_CATEGORIES)
  onSelectitemDeckCategories(event: SelectItemEvent<CallCategory>): void {
    const { nrSeqCategory } = event.item;
    this.historyService.push(Route.NEW_CALL, { nrSeqCategory });
  }
}

export {
  CallCategoriesController,
};
